<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <div class='h-toolbarBg'>
        <ejs-toolbar>
            <e-items>
              <e-item  v-if='isPocShow' prefixIcon='icon hero-icon  hero-icon-upgrade-mptt' :tooltipText='$t("Software.POCUpgrade")'  :click='neClick'></e-item>
              <e-item  v-if='isMcsShow' prefixIcon='icon hero-icon  hero-icon-upgrade-mcc' :tooltipText='$t("Software.MCSUpgrade")'  :click='mcsClick'></e-item>
              <e-item  prefixIcon='icon hero-icon  hero-icon-refresh' :tooltipText='$t("Software.refresh")'    :click='refreshClick' ></e-item>
            </e-items>
        </ejs-toolbar>
        <div class='h-inputBox'>
          <ejs-textbox  :placeholder='$t("Software.enterKeywordSearch")'   @keydown.enter.native="fuzzySearch" v-model='input' />
        </div>
      </div>
      <div>
        <ejs-grid :dataSource='appdata' height='calc(100vh - 236px)' ref='appGrid'>
          <e-columns>
            <e-column field='neName' :headerText='$t("Software.nename")' textAlign='Center' width='20%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='mpttNum' :headerText='$t("Software.versionNo")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='mpttName' :headerText='$t("Software.versionName")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip' ></e-column>
            <e-column field='person' :headerText='$t("Software.uploader")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='uploadTime' :headerText='$t("Software.uploadtime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' type='date' :format='dateFormatOptions'></e-column>
            <e-column field='informState' :headerText='$t("Software.notifystatus")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip' :valueAccessor='informStateFormatter'></e-column>
            <e-column field='downloadState' :headerText='$t("Software.downloadstatus")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'  :valueAccessor='downloadStatusFormatter'></e-column>
            <e-column field='description' :headerText='$t("Software.versiondescription")' textAlign='Center' width='15%' clipMode='EllipsisWithTooltip'></e-column>
          </e-columns>
        </ejs-grid>
        <ejs-pager ref='pager' @click='getUpdateList()' :currentPage='page.pageNo' :pageSize='page.pageSize'
                   :totalRecordsCount='page.totalCount'  :pageCount='page.pageCount'></ejs-pager>
      </div>
      <CustomDialog ref='selectNeDialog' :element='selectNeDialogSetting.element' :styles='selectNeDialogSetting.styles'>
        <template v-slot:dialog-content>
          <NePocQuery ref='selectNeContent'></NePocQuery>
        </template>
      </CustomDialog>
       <CustomDialog ref='selectMcsDialog' :element='selectMcsDialogSetting.element' :styles='selectMcsDialogSetting.styles'>
        <template v-slot:dialog-content>
          <McsQuery ref='selectMcsContent'></McsQuery>
        </template>
      </CustomDialog>
      <CustomDialog ref="tipDialog" v-bind:element="tipDialog.element"  v-bind:styles="tipDialog.styles" >
        <template v-slot:dialog-content>
          <p>{{tipMessage}}</p>
        </template>
      </CustomDialog>
    </template>
  </BasicLayout>
</template>
<script>
import { Reorder, Resize, ExcelExport, ContextMenu } from '@syncfusion/ej2-vue-grids';
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import NePocQuery from  '../../components/software/NePocQuery';
import McsQuery from  '../../components/software/McsQuery';
import {isNullOrUndefined} from "@syncfusion/ej2-base";
import socketInstance from '../../plugins/stompSock';
import { EventBus } from '../../plugins/eventBus';

let dataSource = [];
let filterSource = [];
export default {
  name: 'AppUpdate',
  components:{
    BasicLayout,
    CustomDialog,
    NePocQuery,
    McsQuery
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Software.softManage_AppUpgrade')}`
      },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      page: {
        pageNo: "1",
        pageSize: "15",
        totalCount: "0",
        pageCount: "10"
      },
      selectionOptions: { type: "Multiple" },
      input : "",
      systemId: "1",
      isPocShow: false,
      isMcsShow: false,
      selectNeDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
          },
         element: {
          title: this.$t('Software.AddPOCVersion'),
          target: '#app',
          refName: 'add',
          isClose: true,
          buttonGroup: [
            { click: this.neCancel, buttonModel: { content: this.$t('Software.close') } },
            { click: this.neSubmit, buttonModel: { content: this.$t('Software.save'), isPrimary: true } }
           ]
          }
        },
      selectMcsDialogSetting: {
        styles: {
          width: '810px',
          height: 'auto',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('Software.AddMCSVersion'),
          target: '#app',
          refName: 'add',
          isClose: true,
          buttonGroup: [
            { click: this.mcsCancel, buttonModel: { content: this.$t('Software.close')} },
            { click: this.mcsSubmit, buttonModel: { content: this.$t('Software.save'), isPrimary: true }},
          ]
        }
      },
      tipMessage: "",
      tipDialog: {
        element: {
            target: "#app",
            isClose: true,
            refName: "tip",
            buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Software.cancel')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('Software.cancel')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      },
      appdata: [],
      neType:[2146],
      nePocType:[8],
      downloadStatusMap: new Map(
        [[0,this.$t('Software.downloadSuccess')],
         [-1,this.$t('Software.downloadFailure')],
       ]),
       informStateMap: new Map(
       [ [0,this.$t('Software.informed')],
         [-1,this.$t('Software.unInformed')],
       ]),
      payload: [
        { topic: '/topic/PocVersionServer', clientId: '', callback: this.subscribeCallback }
      ],
    };
  },
  provide() {
    return {
      grid: [Reorder, Resize, ExcelExport, ContextMenu],
      neType: this.neType,
      nePocType: this.nePocType,
    }
  },
  mounted() {
    this.getUpdateList();
    this.querySystemDevice();
    socketInstance.init(this.payload);
  },
  methods: {
    querySystemDevice() {
      const This = this;
      this.$axios.get(`/lte/ems/install/getInstallProducts`).then((response) => {
        console.log("getInstallPackages response", response.data);
        if(response.status == 200) {
          if(response.data !== undefined) {
            console.log("response.data", response.data);
            const deviceList = response.data;
            //Product Map Relation：1)EPC 2)IMS 3)MCS 4)eNodeB 5)eNodeB-IOPS 6)iBS 7)iBS-B
            for(var i = 0; i< deviceList.length; i++) {
              if(deviceList[i] === "2") {//hytalk--Poc3000;hytalk_Pro--Poc6000
                This.isPocShow = true;
                console.log("set isPocShow true");
              }
              else if(deviceList[i] === "9")  {//MCS
                This.isMcsShow = true;
                console.log("set isMcsShow true");
              }
            }
          }
          else {
            This.$parent.showToast('error', this.$t('Software.deviceNotExistInfo'));
          }
        }
      });

    },
    getUpdateList() {
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      this.$loading.showLoadding(this.$t('Software.queryAppSoftwareInfo'), this.$t('SubscriberIms.waitTip'));
      this.$axios.get(`/lte/ems/poc/queryVersions?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}`).then((response) => {
        console.log("getUpdateList response", response);
        if(response.data !== null) {
          if(response.data.errorCode === "SUCCESS") {
            console.log("response.errorCode",response.data.errorCode, response.data.resultVal.result);
            const result = response.data.resultVal;
            This.appdata = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
            //This.page.pageNo   = response.data.resultVal.pageNo;
            //This.page.pageSize = response.data.resultVal.pageSize;
            //This.page.pageCount  = response.data.resultVal.totalPages;
            dataSource= This.appdata ;
            This.$loading.hideLoadding();
          }
          else {
            This.$loading.hideLoadding();
            This.$parent.showToast('error',response.data.errorString);
            console.log("response.errorCode",response.data.errorCode, response.data.resultVal.result);
          }
        }
      });
    },
    subscribeCallback(wsMessage) {
      console.log('callback', wsMessage);
      this.getUpdateList();
    },
    downloadStatusFormatter(field, data, column) {
      return this.downloadStatusMap.get(data[field]);
    },
    informStateFormatter(field, data, column) {
      return this.informStateMap.get(data[field]);
    },
    neClick() {
      this.$refs.selectNeContent.bindValidate();
      this.$refs.selectNeDialog.show();
    },
    neCancel() {
      this.$refs.selectNeDialog.close();
    },
    submitPocAction() {
      console.log("step into submitPocAction");
      const This = this;
      var queryData = This.$refs.selectNeContent.getNeQueryData();

      if(queryData === undefined) {
        console.log("AppUpdate  submitMCSAction queryData is null");
        return;
      }

      console.log("AppUpdate  submitPocAction queryData queryData.md5Code",queryData,queryData.md5Code);
      var mpttFile = document.getElementById(queryData.mpttFileId).files[0];
      if(mpttFile === undefined) {
        console.log("AppUpdate  submitPocAction read mpttFile is null");
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Software.pleaseUploadFile')});
        return;
      }

      if(isNullOrUndefined(queryData.neid)) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Software.pleaseSelectNe')});
        return;
      }

      const formData = new FormData();
      formData.append('md5Code', queryData.md5Code);
      formData.append('person', queryData.person);
      formData.append('mpttFile', mpttFile);
      formData.append('neid', queryData.neid)
      formData.append('systemId', queryData.systemId);

      console.log("AppUpdate  submitPocAction queryFormData md5Code mpttFile", formData.get("md5Code"), formData.get("mpttFile"));
      let config = {
        headers: {
           "Content-Type": "multipart/form-data"
        }
      };
      this.$loading.showLoadding(this.$t('Software.Uploading'), mpttFile.name);
      This.$axios.post('/lte/ems/poc/addVersionAction', formData, config).then(response => {
        this.resdata = response.data;
        if(this.resdata !== [] && response.data.errorCode == 'SUCCESS'){
          this.getUpdateList();
          This.$loading.hideLoadding();
          this.$refs.selectNeDialog.close();
        }
        else {
          This.$loading.hideLoadding();
          This.$parent.showToast('error',response.data.errorString);
        }
      });
    },

    submitMCSAction() {
      console.log("step into submitMCSAction");
      const This = this;
      var queryData = This.$refs.selectMcsContent.getMcsQueryData();

      if(queryData === undefined) {
          console.log("AppUpdate  submitMCSAction queryData is null");
          return;
      }

      console.log("AppUpdate  submitMCSAction queryData queryData.md5Code queryData.mpttFileId",queryData,queryData.md5Code,queryData.mpttFileId);
      var mpttFile = document.getElementById(queryData.mpttFileId).files[0];
      if(mpttFile === undefined) {
        console.log("AppUpdate  submitMCSAction  read mpttFile is null");
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Software.pleaseUploadFile')});
        return;
      }

      if(isNullOrUndefined(queryData.neid)) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Software.pleaseSelectNe')});
        return;
      }

      const formData = new FormData();
      formData.append('md5Code', queryData.md5Code);
      formData.append('person', queryData.person);
      formData.append('mpttFile', mpttFile);
      formData.append('neid', queryData.neid)
      formData.append('systemId', queryData.systemId);

      console.log("AppUpdate submitMCSAction queryFormData md5Code mpttFile", formData.get("md5Code"), formData.get("mpttFile"));
      let config = {
        headers: {
           "Content-Type": "multipart/form-data"
        }
      };
      this.$loading.showLoadding(this.$t('Software.Uploading'), mpttFile.name);
      This.$axios.post('/lte/ems/poc/addMCSVersionAction', formData, config).then(response => {
        this.resdata = response.data;
        if(this.resdata !== [] && response.data.errorCode == 'SUCCESS'){
          this.getUpdateList();
          This.$loading.hideLoadding();
          this.$refs.selectMcsDialog.close();
        }
        else {
          This.$loading.hideLoadding();
          This.$parent.showToast('error',response.data.errorString);
        }
      });
    },
    neSubmit() {
      console.log("neSubmit");
      this.submitPocAction();
    },
    dialogHide() {
      this.$refs.tipDialog.close();
    },
    mcsClick() {
      this.$refs.selectMcsContent.bindValidate();
      this.$refs.selectMcsDialog.show();
    },
    refreshClick() {
      this.getUpdateList();;
    },
    mcsCancel() {
      this.$refs.selectMcsDialog.close();
    },
    mcsSubmit() {
      console.log("mcsSubmit");
      this.submitMCSAction();
    },

    fuzzySearch(args) {
      console.log("fuzzySearch  this.input", this.input);
      if(this.input === '') {
        this.getUpdateList();
      }
      else {
        const This = this;
        This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
        this.$loading.showLoadding(this.$t('Software.queryAppSoftwareInfo'), this.$t('SubscriberIms.waitTip'));
        this.$axios.get(`/lte/ems/poc/queryVersions?pageNo=${This.page.pageNo}&pageSize=${This.page.pageSize}&neName=${String(encodeURIComponent(this.input))}`).then((response) => {
        console.log("getUpdateList response", response);
        if(response.data !== null) {
          if(response.data.errorCode === "SUCCESS") {
            console.log("response.errorCode",response.data.errorCode, response.data.resultVal.result);
            const result = response.data.resultVal;
            This.appdata = response.data.resultVal.result;
            This.page.totalCount = response.data.resultVal.totalCount;
            dataSource= This.appdata ;
            This.$loading.hideLoadding();
          }
          else {
            This.$loading.hideLoadding();
            This.$parent.showToast('error', response.data.errorString);
            console.log("response.errorCode",response.data.errorCode, response.data.resultVal.result);
          }
        }
      });
     }
    },
    search(input,source,columns,maparray) {
      var filterData = source.filter( item => {
        let columntext = Array.from(columns, x => {
            return x.field;
        });
        let feildData = Array.from(columntext, x => {
          if(maparray && maparray.has(x)) {
            let value = maparray.get(x).get(item[x]);
            return isNullOrUndefined(value) ? '' : value;
          }
          else {
            return isNullOrUndefined(item[x]) ? '' : item[x] +'';
          }
        });
        let fire = false;
        feildData.forEach(item => {
          if(item.indexOf(input) > -1) {
            fire = true;
          }
        });
        return fire;
      }).map( item => { return item });
        return filterData;
    }
  },
}
</script>
